<template>
    <div class="auth_success">
        <i class="el-icon-success Success"></i><br />
        授权成功<br />
        {{ second }} 秒自动关闭 <a @click="close" style="cursor: pointer">点击关闭</a>
    </div>
</template>

<style>
.auth_success {
    width: 100%;
    height: 100%;
    text-align: center;
    padding-top: 15%;
    line-height: 200%;
}
.auth_success .el-icon-success {
    font-size: 48px;
    color: #67c23a;
}
</style>


<script>
export default {
    data() {
        return {
            second: 5
        };
    },
    created() {
        this.Data.ComponentApp.Auth(this.$route.query.auth_code).then(res => {
            if (window.opener) window.opener.location.reload()
        });
        setInterval(() => {
            if (this.second <= 0) this.close();
            else this.second--;
        }, 1000);
    },
    methods: {
        close() {
            window.open("about:blank", "_top").close()
        },
    },
};
</script>